import { Outlet } from 'react-router-dom';

const AdminLayout = () => (
  <main>
    <Outlet />
  </main>
);

export default AdminLayout;
